import React from 'react';
import DnDRow from 'components/lib/tables/dnd/DnDRow';
import styles from 'styles/components/lib/tables/dnd/dndBucketRows.css';

const DnDBucketRows = ({ columns, draggedRowsKeys, isUnactive, parent, rows, ...props}) => {
  return (
    <div className={styles.dndBucketRows} id={`bucket${parent.key}`}>
      { rows.map((row, key) => {
        let isSelected = draggedRowsKeys.indexOf(row.key) > -1;
        return (
          row.key ?
              <div key={key} style={{margin: '10px 0px 10px 40px'}}>
                <DnDRow
                  columns={columns}
                  errorMessage={props.errorMessage}
                  row={row}
                  hasParent={true}
                  id={row.key}
                  index={key}
                  isSelected={isSelected}
                  isNewBucket={props.isNewBucket}
                  isEditing={props.isEditing}
                  isUnactive={isUnactive}
                  isNewBucketCreation={props.isNewBucketCreation}
                  parent={parent}
                  name={props.name}
                  onDeleteChild={(e) => props.onDeleteChild(e, {key: row.key, index: key})}
                  onDragAdd={props.onDragAdd}
                  onDragOver={props.onDragOver}
                  onDragRemove={props.onDragRemove}
                  onDragEnd={props.onDragEnd}
                  onDragLeave={props.onDragLeave}
                  onTouchEnd={props.onTouchEnd}
                  onTouchStart={props.onTouchStart}
                  onSelect={props.onSelect}
                  packages={props.packages}
                  isTouchDevice={props.isTouchDevice} />
              </div>
            : <div key={key} style={{height: '0px'}} /> );
        })}
    </div>
  );
};


export default DnDBucketRows;



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DnDBucketRows.js